module.exports = __webpack_public_path__ + "static/img/8.366ee79.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/5/zh/8.png
// module id = jCs0
// module chunks = 0